import axios from 'axios';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function useUnauthenticatedAxios(langOverride?: string | null) {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const instance = axios.create({
      baseURL: import.meta.env.REACT_APP_API_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    instance.interceptors.request.use((config) => {
      return {
        ...config,
        params: {
          ...config.params,
          lang: langOverride === null ? undefined : (langOverride ?? i18n.language),
        },
      };
    });

    return instance;
  }, [i18n.language, langOverride]);
}
